document.addEventListener('DOMContentLoaded', () => {
	if(document.querySelector('.jsScrollUp')){
		let button = document.querySelector('.jsScrollUp');

		button.addEventListener('click', () => {
			document.querySelector('body').scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		})
		
		document.addEventListener('scroll', () => {
			if(window.pageYOffset >= (window.innerHeight * 1)){
				button.classList.add('is-visible')
			} else{
				button.classList.remove('is-visible')
			}
		})
	}
})
